import {useEffect, useRef, useState} from 'react'
import _ from 'lodash'
import utils from '@eitje/utils'
import {Icon} from '../icon'
import {Layout} from '../layout'
import {useMergedRefs} from '../layout/helpers'
import {Text} from '../text'
import './styles/index.less'

export const Message = ({ref, t, mdT, icon, children, colorSet = 'color-bordered-fill', margin = 8, textProps = {}, ...rest}) => {
	const [messageHeight, setMessageHeight] = useState(0)
	const layoutRef = useRef()
	const mergedRef = useMergedRefs(ref, layoutRef)
	const multiLine = messageHeight > 32

	useEffect(() => {
		setMessageHeight(layoutRef.current?.clientHeight)
	}, [children])

	// Convert children to text, but also allow components and elements to be passed,
	// such as <br/> and <ModalLink/>. Those should not be converted to strings by Text's
	// inner logic, so simply pass them as JSX.
	children = utils.alwaysArray(children).map(child => {
		return _.isString(child) ? <Text children={child} {...textProps} /> : child
	})

	const vertical = (multiLine && icon) || children.length > 1
	const direction = vertical ? 'vertical' : 'horizontal'

	return (
		<Layout
			direction={direction}
			ref={mergedRef}
			horizontal="center"
			className="message"
			colorSet={colorSet}
			padding="4 8"
			margin={margin}
			border
			borderRadius
			minHeight={32}
			width={null} // needed, because otherwise layout gets 100% width due to direction prop
			{...rest}
		>
			{icon && <Icon name={icon} />}
			{(t || mdT) && <Text t={t} mdT={mdT} {...textProps} />}
			{children}
		</Layout>
	)
}
